/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const aqua: QtmColor = {
  50: '#dff7fb',
  100: '#b0eaf4',
  200: '#7cddec',
  300: '#44cee4',
  400: '#05c3dd',
  500: '#00bad7',
  600: '#00aac4',
  700: '#0095a9',
  800: '#008191',
  900: '#005e65',
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.black,
    700: common.black,
    800: common.white,
    900: common.white,
  },
};

export default aqua;
